import { defineComponent as D, computed as n, createBlock as d, openBlock as t, unref as o, normalizeClass as c, withCtx as B, createElementBlock as v, createElementVNode as l, createCommentVNode as u, renderSlot as f, resolveDynamicComponent as S, toRaw as z, Fragment as L } from "vue";
import { RevButtonBase as N } from "@ds/components/ButtonBase";
import { RevSpinner as h } from "@ds/components/Spinner";
import { usePropsValidation as R } from "../../composables/usePropsValidation.js";
import { useI18n as T } from "@ds/plugin";
import V from "../../translations/generic.translations.js";
import { tw as e } from "../../utils/tailwind.js";
const _ = {
  key: 0,
  class: "pointer-events-none flex items-center"
}, j = { class: "body-2-bold pointer-events-none truncate" }, A = ["aria-hidden"], E = { class: "body-1-bold truncate" }, G = /* @__PURE__ */ D({
  name: "RevButton",
  __name: "Button",
  props: {
    ariaDescribedby: { default: void 0 },
    ariaLabelledby: { default: void 0 },
    ariaLabel: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    fullWidth: { default: "never" },
    icon: { default: void 0 },
    loading: { type: Boolean, default: !1 },
    loadingAlternativeText: { default: void 0 },
    size: { default: "medium" },
    to: { default: void 0 },
    variant: {},
    tracking: { default: () => ({}) }
  },
  emits: ["click"],
  setup(p, { emit: g }) {
    const a = p, y = g, x = T(), b = a.loadingAlternativeText || x(V.buttonLoading), s = n(() => a.disabled || a.loading), k = n(() => s.value ? "" : a.to);
    function w(i) {
      s.value || y("click", i);
    }
    const r = n(() => a.size === "small"), C = n(() => [
      e`focus-visible-outline-default-hi rounded-sm relative max-w-full select-none no-underline motion-safe:ease-in`,
      r.value ? [
        e`inline-flex items-center justify-center  motion-safe:transition motion-safe:duration-300`,
        (a.variant === "primary" || a.variant === "primaryDestructive" || a.variant === "primarySuccess") && e`px-12 py-6`,
        (a.variant === "secondary" || a.variant === "secondaryDestructive" || a.variant === "secondarySuccess") && e`px-11 py-5`
      ] : [
        e`inline-block w-auto hover:no-underline motion-safe:transition-colors motion-safe:duration-200`,
        a.loading && e`overflow-hidden`,
        (a.variant === "primary" || a.variant === "primaryDestructive" || a.variant === "primarySuccess") && e`px-16 py-12`,
        (a.variant === "secondary" || a.variant === "secondaryDestructive" || a.variant === "secondarySuccess") && e`px-15 py-11`
      ],
      {
        always: e`w-full`,
        never: "",
        adaptive: e`w-full min-w-80 md:w-auto`
      }[a.fullWidth],
      s.value ? e`cursor-not-allowed` : e`cursor-pointer`,
      {
        primary: [
          e`bg-action-default-hi text-onaction-default-hi`,
          e`hover:bg-action-default-hi-hover`,
          e`disabled:bg-action-default-hi-disabled disabled:text-onaction-default-hi-disabled`
        ],
        primaryDestructive: [
          e`bg-action-danger-hi text-onaction-danger-hi`,
          e`hover:bg-action-danger-hi-hover`,
          e`disabled:bg-action-danger-hi-disabled disabled:text-onaction-danger-hi-disabled`
        ],
        primarySuccess: [
          e`bg-action-success-hi text-onaction-success-hi`,
          e`hover:bg-action-success-hi-hover`,
          e`disabled:bg-action-default-hi-disabled disabled:text-onaction-default-hi-disabled`
        ],
        secondary: [
          e`bg-action-default-min border-action-default-hi`,
          e`text-action-default-hi border border-solid`,
          e`hover:bg-action-default-min-hover`,
          e`disabled:bg-action-default-min-disabled disabled:border-action-default-hi-disabled disabled:text-onaction-default-hi-disabled`
        ],
        secondaryDestructive: [
          e`bg-action-danger-min border-action-danger-hi`,
          e`text-action-danger-hi border border-solid`,
          e`hover:bg-action-danger-min-hover`,
          e`disabled:bg-action-danger-min-disabled disabled:border-action-default-hi-disabled disabled:text-onaction-danger-hi-disabled`
        ],
        secondarySuccess: [
          e`bg-action-success-min border-action-success-hi`,
          e`text-action-success-hi border border-solid`,
          e`hover:bg-action-success-min-hover`,
          e`disabled:bg-action-success-min-disabled disabled:border-action-default-hi-disabled disabled:text-onaction-danger-hi-disabled`
        ]
      }[a.variant]
    ]), m = n(() => [
      e`pointer-events-none flex items-center`,
      r.value ? e`space-x-8` : e`justify-center`,
      a.loading && e`invisible`
    ]);
    return R({
      'Component in "medium" size can\'t have an `icon`. Use "small" size instead.': () => a.size === "medium" && a.icon !== void 0
    }), (i, W) => (t(), d(o(N), {
      "aria-describedby": i.ariaDescribedby,
      "aria-disabled": s.value,
      "aria-label": i.ariaLabel,
      "aria-labelledby": i.ariaLabelledby,
      class: c(C.value),
      disabled: i.disabled,
      to: k.value,
      tracking: i.tracking,
      onClick: w
    }, {
      default: B(() => [
        r.value ? (t(), v("span", _, [
          l("span", {
            class: c(m.value)
          }, [
            l("span", j, [
              f(i.$slots, "default")
            ]),
            i.icon ? (t(), d(S(z(i.icon)), {
              key: 0,
              size: "small"
            })) : u("", !0)
          ], 2),
          i.loading ? (t(), d(o(h), {
            key: 0,
            "alternative-text": o(b),
            class: "absolute inset-0 mx-auto h-full",
            size: "small"
          }, null, 8, ["alternative-text"])) : u("", !0)
        ])) : (t(), v(L, { key: 1 }, [
          i.loading ? (t(), d(o(h), {
            key: 0,
            "alternative-text": o(b),
            class: "absolute inset-0 m-auto w-full"
          }, null, 8, ["alternative-text"])) : u("", !0),
          l("span", {
            "aria-hidden": i.loading,
            class: c(m.value)
          }, [
            l("span", E, [
              f(i.$slots, "default")
            ])
          ], 10, A)
        ], 64))
      ]),
      _: 3
    }, 8, ["aria-describedby", "aria-disabled", "aria-label", "aria-labelledby", "class", "disabled", "to", "tracking"]));
  }
});
export {
  G as default
};
